export const DEFAULT_SHARING_SETTINGS = {
  shareMode: 'link',
  allowFullStoryShare: true,
  allowMomentShare: true,
};

export const SHARE_MODE_OPTIONS = [
  {
    value: 'private',
    label: 'Sharing Off',
    description: 'Hide share buttons. Anyone who already has the page link may still be able to open it.',
  },
  {
    value: 'link',
    label: 'Link Access',
    description: 'Anyone with the gift link can open the full page. Share only with trusted people.',
  },
  {
    value: 'moments',
    label: 'Share Card Only',
    description: 'Hide full-page share buttons. Let them save or share only the final keepsake card.',
  },
];

export const getShareSettingsForMode = (shareMode) => {
  if (shareMode === 'private') {
    return { shareMode, allowFullStoryShare: false, allowMomentShare: false };
  }
  if (shareMode === 'moments') {
    return { shareMode, allowFullStoryShare: false, allowMomentShare: true };
  }
  return { shareMode: 'link', allowFullStoryShare: true, allowMomentShare: true };
};

export const normalizeSharingSettings = (settings = {}) => {
  if (settings.shareMode) {
    return {
      ...DEFAULT_SHARING_SETTINGS,
      ...settings,
      ...getShareSettingsForMode(settings.shareMode),
    };
  }
  if (settings.allowFullStoryShare === false && settings.allowMomentShare !== false) {
    return { ...settings, ...getShareSettingsForMode('moments') };
  }
  if (settings.allowFullStoryShare === false && settings.allowMomentShare === false) {
    return { ...settings, ...getShareSettingsForMode('private') };
  }
  return { ...DEFAULT_SHARING_SETTINGS, ...settings, shareMode: 'link' };
};
